'use client';

import { useSyncExternalStore } from 'react';

import type { BeforeSendMiddleware } from '@vercel/speed-insights';
import { SpeedInsights } from '@vercel/speed-insights/react';

import {
  getAnalyticsConsent,
  subscribeAnalyticsConsent,
} from '~/lib/marketing/measurement';
import { performanceLocation } from '~/lib/marketing/performance';

const serverConsent = () => 'unknown' as const;

// The loaded SDK stays alive after unmount. Check the current choice for every
// delivery so withdrawal also blocks delayed vitals and SPA navigation events.
const beforeSend: BeforeSendMiddleware = (event) => {
  if (getAnalyticsConsent() !== 'accepted') return null;
  const url = performanceLocation(event.url);
  if (!url) return null;
  return { type: event.type, url, route: new URL(url).pathname };
};

export function PerformanceInsights({ enabled }: { enabled: boolean }) {
  const consent = useSyncExternalStore(
    subscribeAnalyticsConsent,
    getAnalyticsConsent,
    serverConsent,
  );
  if (
    !enabled ||
    consent !== 'accepted' ||
    !performanceLocation(window.location.href)
  ) {
    return null;
  }
  return <SpeedInsights beforeSend={beforeSend} debug={false} />;
}
